import { JsonView, allExpanded, defaultStyles } from "react-json-view-lite";

export function Json({ value }: { value: unknown }) {
  if (value === undefined || value === null) {
    return <span className="text-slate-400 italic">null</span>;
  }
  return (
    <div className="json-view">
      <JsonView
        data={value as object}
        shouldExpandNode={(level) => level < 2}
        style={defaultStyles}
      />
    </div>
  );
}

export const _allExpanded = allExpanded;
